import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ItemTypesActions, AsyncActions } from './item-types.actions';
import { ManagementBaseActions } from '../base/management-base.actions';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {SearchFilter} from '@emm/core/models/search-filter';
import {withLoadables} from '@emm/core/util/ngrx.util';
import {ItemType} from '@emm/core/models/item-type.model';

export const itemTypesFeatureKey = 'itemTypes';

export interface ItemTypesState extends EntityState<ItemType>, AsyncActionState {
    selectedTag: string | null;
    searchFilter: SearchFilter;
}

export const adapter: EntityAdapter<ItemType> = createEntityAdapter<ItemType>({
    selectId: (item: ItemType) => item.tag,
    sortComparer: null
});

export const initialState: ItemTypesState = adapter.getInitialState({
    selectedTag: null,
    searchFilter: null,
    ...asyncActionState.initial
});

const { loadActions, successActions, errorActions } = AsyncActions;

export const itemTypesReducer = withLoadables<ItemTypesState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(
        ManagementBaseActions.initItemTypes,
        ManagementBaseActions.initItems,
        ManagementBaseActions.initItemGroupings,
        () => ({
            ...initialState
        })
    ),

    on(ItemTypesActions.loadAll, ItemTypesActions.deleteSuccess, (state: ItemTypesState) => ({
        ...state,
        selectedTag: null
    })),

    on(
        ItemTypesActions.loadAllSuccess,
        ItemTypesActions.loadAllForItemsSuccess,
        ItemTypesActions.loadAllForItemGroupsSuccess,
        (state: ItemTypesState, { itemTypes }) => adapter.setAll(itemTypes, state)
    ),

    on(ItemTypesActions.select, (state: ItemTypesState, { tag }) => ({
        ...state,
        selectedTag: tag
    })),

    on(ItemTypesActions.searchItemTypes, (state: ItemTypesState, { filter }) => ({
        ...state,
        searchFilter: filter
    })),

    on(ManagementBaseActions.updateItemTypeSuccess, (state: ItemTypesState, action) =>
        adapter.upsertOne(action.itemType, state)
    )

);
